if (!customElements.get('complementary-products')) {
  customElements.define('complementary-products', class ComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const choose = event.target.closest('[data-complementary-choose]');
      const variant = event.target.closest('[data-complementary-variant]');
      const add = event.target.closest('[data-complementary-add]');
      if (choose) this.toggleItem(choose.closest('[data-complementary-item]'));
      if (variant && !variant.disabled) this.selectVariant(variant);
      if (add && !add.disabled) this.addToCart(add);
    }

    toggleItem(item) {
      const willOpen = !item.classList.contains('is-open');
      this.querySelectorAll('[data-complementary-item].is-open').forEach((openItem) => this.setOpen(openItem, false));
      this.setOpen(item, willOpen);
    }

    setOpen(item, open) {
      item.classList.toggle('is-open', open);
      const choose = item.querySelector('[data-complementary-choose]');
      const options = item.querySelector('[data-complementary-options]');
      if (choose) choose.setAttribute('aria-expanded', String(open));
      if (options) options.hidden = !open;
    }

    selectVariant(button) {
      const item = button.closest('[data-complementary-item]');
      item.querySelectorAll('[data-complementary-variant]').forEach((choice) => choice.classList.toggle('is-selected', choice === button));
      const price = button.dataset.price;
      item.querySelector('[data-complementary-price]').textContent = price;
      item.querySelector('[data-complementary-selected-price]').textContent = price;
      const add = item.querySelector('[data-complementary-add]');
      add.dataset.variantId = button.dataset.variantId;
      add.disabled = false;
      const imageUrl = button.dataset.image;
      const image = item.querySelector('[data-complementary-image]');
      if (imageUrl && image) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
      }
    }

    async addToCart(button) {
      const item = button.closest('[data-complementary-item]');
      const status = item.querySelector('[data-complementary-status]');
      const cart = document.querySelector('cart-drawer');
      button.disabled = true;
      button.classList.add('is-loading');
      status.textContent = '';
      const formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', '1');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
        status.textContent = '✓ Ajouté';
        if (cart) cart.renderContents(data);
        else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        window.setTimeout(() => { status.textContent = ''; }, 1800);
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
}
